import { createSelector, type Selector } from 'reselect';
import type { AppState } from 'src/reducers';
import type { MemberItem, LevelItem, LevelInfo, DimensionConfigResponse } from 'src/types/Scope';

export interface DimensionMap {
  [key: string]: LevelItem & {
    members: MemberItem[];
  };
}

const getDimensionConfigResponse: Selector<AppState, DimensionConfigResponse | null> = (state) => {
  return state.scope.dimensionConfig;
};

function createDimensionSelector(levelInfos: LevelInfo[]) {
  const pds = {} as DimensionMap;
  levelInfos.forEach((levelInfo) => {
    const { level, members } = levelInfo;
    pds[levelInfo.level.id] = {
      ...level,
      members,
    };
  });
  return pds;
}

export const getProductMapSelector = createSelector(getDimensionConfigResponse, (config) => {
  if (config) {
    return createDimensionSelector(config.product.levelInfos);
  }
  return {};
});

export const getLocationMapSelector = createSelector(getDimensionConfigResponse, (config) => {
  if (config) {
    return createDimensionSelector(config.location.levelInfos);
  }
  return {};
});

export const getProductLevels = createSelector(getDimensionConfigResponse, (config) => {
  let levels: LevelItem[] = [];
  if (config) {
    levels = config.product.levelInfos.map((levelInfo: LevelInfo) => {
      return levelInfo.level;
    });
  }
  return levels;
});

export const getLocationLevels = createSelector(getDimensionConfigResponse, (config) => {
  let levels: LevelItem[] = [];
  if (config) {
    levels = config.location.levelInfos.map((levelInfo: LevelInfo) => {
      return levelInfo.level;
    });
  }
  return levels;
});

export const getLocationMembers = createSelector(getDimensionConfigResponse, (config) => {
  let levels: LevelItem[] = [];
  if (config) {
    levels = config.location.levelInfos.map((levelInfo: LevelInfo) => {
      return levelInfo.level;
    });
  }
  return levels;
});
